/** La pelle dei pulsanti del sito, scritta una volta sola.
 *
 *  Il sito aveva due famiglie di pulsanti. Quella della prima pagina
 *  (stile A): pieno sabbia `#c3aa7c` col testo petrolio, Geist 13,
 *  raggio 0-2. Quella del resto del sito (stile B): pieno `bg-accent`,
 *  che nella tavolozza calda è il sabbia scuro `#7a5a24` con l'avorio
 *  sopra, monospazio 10-12 in maiuscolo spaziato, raggio 6
 *  (`rounded-sm`, che qui vale `0.6 × --radius`). Passando da una rotta
 *  all'altra lo stesso invito cambiava colore, carattere e forma.
 *
 *  Il riferimento è lo stile A. Queste costanti portano solo colore,
 *  carattere, raggio e comportamento: la misura (padding, altezza,
 *  larghezza, allineamento) resta a chi le usa, perché cambia davvero da
 *  un posto all'altro. `PULSANTE_SABBIA` (components/home/stile.ts) e
 *  `TASTO_RULLO` (components/rullo/stile.ts) sono composti da qui.
 *
 *  Modulo senza direttiva: lo leggono Server e Client Component (una
 *  costante esportata da un file "use client" e letta dal server non è
 *  il suo valore, vedi LEAD_DISPACCI nei learnings).
 *
 *  Contrasti (WCAG), misurati sui token `--oi-home-*`: petrolio
 *  `#162b37` sul sabbia `#c3aa7c` 6,52:1 in tutti e due i temi, perché i
 *  due toni non cambiano col tema. Vale anche dentro `.oi-editoriali`, che
 *  dal 30/09/2026 usa la stessa tavolozza. */

/** Il contorno del fuoco da tastiera: sempre visibile, fuori dalla
 *  scatola, nel colore dell'accento. */
export const FUOCO = "focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-accent";

/** Il pieno sabbia senza raggio: per il pulsante incassato in una
 *  cornice (il «Cerca» della barra), dove un angolo tondo contro il
 *  campo accanto si vedrebbe. */
export const PIENO =
  `bg-sabbia font-sans text-voce font-semibold text-suSabbia no-underline transition-opacity hover:opacity-90 ${FUOCO}`;

/** Il pulsante pieno, cioè l'azione principale di un blocco. */
export const PULSANTE_PIENO = `rounded-[2px] ${PIENO}`;

/** Il pulsante di contorno: azioni secondarie, paginazione, «indietro». */
export const PULSANTE_CONTORNO =
  `border border-rule bg-transparent font-sans text-voce font-medium text-ink no-underline transition-colors hover:border-sommesso hover:bg-surface2 ${FUOCO}`;

/** Il solo carattere dell'invito con la freccia: Geist 12 in tondo, al
 *  posto del monospazio a dieci pixel in maiuscolo spaziato. Per gli
 *  inviti che tengono un colore loro (il tono di una scheda, il bianco
 *  su un pannello scuro). */
export const INVITO_CARATTERE = "font-sans text-meta font-medium";

/** L'invito con la freccia, senza scatola: «Apri il manuale ↗». */
export const INVITO =
  `${INVITO_CARATTERE} text-acciaio no-underline transition-colors hover:text-ink ${FUOCO}`;

/** Lo stesso invito in coda a una scheda tutta cliccabile: si accende
 *  col passaggio sulla scheda (`group`), e il fuoco lo porta la scheda. */
export const INVITO_SCHEDA =
  `${INVITO_CARATTERE} text-acciaio transition-colors group-hover:text-ink`;
